import version from './appversion';
import './launch';

// tslint:disable-next-line
console.log(`[NoteService] Client Version ${version}`);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/index.tsx